import React from 'react';
import EditContactData from 'components/atoms/edit_contact_data';

const EditContact: React.FC = () => {
  return (
    <div className="page-container">
      <EditContactData />
    </div>
  );
};
export { EditContact };
